import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";
import { forkJoin } from "rxjs";
@Component({
  selector: "app-employes",
  templateUrl: "./employes.component.html",
  styleUrls: ["./employes.component.scss"],
})
export class EmployesComponent implements OnInit {
  selectedLanguage = "";
   font = "";
   fetchinData = true;
   ContentData: any[] = [];
   all_employee_data: any[] = [];
   all_teachers_info: any[] = [];
   paginated_teachers_info: any[] = [];
   schoolTeacher: any[] = [];
   length = 0;
   pageSize = 15;
   pageIndex = 0;
   totalPages: number[] = [];
 
   constructor(private appService: AppService) {}
 
   ngOnInit(): void {
     this.FetchCollegeTeacherInfo();
   }
 
   FetchCollegeTeacherInfo() {
     forkJoin([this.appService.getTeaherStaff()]).subscribe((response: any) => {
       console.log(response, "response FetchData");
       this.ContentData = response[0].data;
       console.log(this.ContentData, "Default Content Data");
       if (this.ContentData != null) {
         // Filter Teacher Data
         this.all_teachers_info = this.ContentData.filter(
           (x) => x.SalarySheet === "Staff" && x.IsActive === true
         );
         console.log(this.all_teachers_info, "All staff info");
         this.length = this.all_teachers_info.length;
         this.generatePageNumbers();
         this.paginateData();
       }
       this.fetchinData = false;
     });
   }
 
   onPageChange(pageIndex: number) {
     this.pageIndex = pageIndex;
     this.paginateData();
   }
 
   paginateData() {
     const startIndex = this.pageIndex * this.pageSize;
     const endIndex = startIndex + this.pageSize;
     this.paginated_teachers_info = this.all_teachers_info.slice(
       startIndex,
       endIndex
     );
   }
 
   generatePageNumbers() {
     const totalPageCount = Math.ceil(this.length / this.pageSize);
     this.totalPages = Array.from({ length: totalPageCount }, (_, i) => i + 1);
   }
 
   GetFontName() {
     switch (this.selectedLanguage) {
       case "en":
         return "Congenial";
       case "bn":
         return "Kalpurush";
       case "ar":
         return "Jameel Noori Nastaleeq";
     }
   }
 }
 